(function($) {

    $(document).on("click", ".point", function() {
        $('.point').removeClass("active");
        $(this).addClass("active");       
    });

    $(document).on("click", ".pop_up_link", function(event) {
        console.log(event);
        var pop_to_show = $(this).attr("data-attr");
        $(".pop_up_link").removeClass("active_tab");
        $(this).addClass("active_tab");
        $(".popup").removeClass("active_hidden_section");
        $("." + pop_to_show).addClass("active_hidden_section");
    });

    $(document).on("click", ".close_pop", function(event) {
        console.log(event);
        $(".popup").removeClass("active_hidden_section");
    });

    $(document).on("click", ".faq_title", function() {
        var sectors_to_show = $(this).attr("data-attr");

        console.log(sectors_to_show);
      
        if ($(this).hasClass("active_tab")) {
          
          $(this).removeClass("active_tab");
          $("." + sectors_to_show).removeClass("active_hidden_section");
          $(this).find('.faq__expand-arrow').removeClass("faq__expand-arrow__active");
          
        } else {
          
          $(this).addClass("active_tab");
          $("." + sectors_to_show).addClass("active_hidden_section");
          $(this).find('.faq__expand-arrow').addClass("faq__expand-arrow__active");
          
        }
    });

    $(".accordion_title").on("click", function(event) {
        var accordion_to_show = $(this).attr("data-attr");
      
        if ($(this).hasClass("active")) {
      
          $(".accordion_title").removeClass("active");
          $(".accordion").removeClass("accordion_active_hidden_section");
          
        } else {
      
          $(".accordion_title").removeClass("active");
          $(".accordion").removeClass("accordion_active_hidden_section");
        
          $(this).addClass("active");
          $("." + accordion_to_show).addClass("accordion_active_hidden_section");
          
        }
    });
   
    // Services Menu

    $(document).on("click", ".parent svg", function(event) {

      console.log("Clicked parent");

        $(this).closest(".services_nav").find(".parent>a").removeClass("open");
        // $(this).closest(".services_nav").find(".child_links").removeClass("open"); 

        $(this).addClass('open');
        $(this).next().toggleClass('open');

      });

        $(document).on("click", ".child_links svg", function(event) {

          console.log("clicked child");
          
          $(this).find(".grand_child_links").toggleClass("open");
          
        });

    // $(document).on("click", ".parent > a ", function(event) {

    //   console.log("Clicked parent");

    //   if ($(this).hasClass('open')) { 
    //     // Do nothing
    //   } else {
    //     $(this).closest(".services_nav").find(".parent>a").removeClass("open");
    //     $(this).closest(".services_nav").find(".child_links").removeClass("open"); 
        
    //     $(this).addClass('open');
    //     $(this).next().toggleClass('open');
        
    //     return false;
    //   }

    // });


  
    // $(document).on("click", ".child_links>li>a", function(event) {

    //   console.log("clicked");
      
    //   event.preventDefault();

    //   $(this).toggleClass('open');

    //   if ($(this).hasClass('open')) {
    //     console.log("child has class"); 
    //     $(this).unbind(); 
    //   }

    //   $(this).next().toggleClass("open");
      
    // });

    // setTimeout(function(){ 
    //     $(".product-form__submit").attr("disabled", true);
    // }, 3300);

    // $(".js.product-form__input.inputs_add_1 input").on("click", function(event) {
    //     console.log(event);
    //     $(".product-form__submit").attr("disabled", false);
    //     $(".product-form__submit").addClass("active"); 
    // });
      
})
(jQuery); 